export default __webpack_public_path__ + "static/media/game-forever-nobg.61ffa620.png";